import { useState } from "react";
import { PageTabs } from "../component/list/PageTabs";
import { Box, Typography } from "@mui/material";
import { useAtomValue } from "jotai";
import { AppAtoms } from "../lib/store";

import DataChatPanel from "../component/DataChatPanel";

function DataAnalysis() {
  const isSmartPhone = useAtomValue(AppAtoms.isSmartPhone);
  const loginUser = useAtomValue(AppAtoms.loginUser);
  const isTossup = loginUser?.db_authority === 'トスアップアカウント';
  const [serchOpen, setSerchOpen] = useState(false);

  return (
    <Box
      data-testid="data-analysis-page"
      sx={{ height: "100%", display: "flex", flexDirection: "column" }}
    >
      <PageTabs group="analytics" />
      <Box
        sx={{
          flex: 1,
          minHeight: 0,
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Typography
          variant="h6"
          sx={{ px: 2, pt: 1, pb: 0.5, color: "var(--color-sumi-heading, #464646)" }}
        >
          AIデータ分析
        </Typography>
        <Box sx={{ flex: 1, minHeight: 0 }}>
          { !isTossup && <DataChatPanel /> }
        </Box>
      </Box>
    </Box>
  );
}

export default DataAnalysis;
